// extracted by mini-css-extract-plugin
export default {"container":"zp-z","brandName":"Ap-z","productName":"Bp-z","productNamePdpEnhancements":"Cp-z","breakLongProductName":"Dp-z"};